export default __webpack_public_path__ + "static/media/product.c040e60c.svg";